import React, { useEffect, useId, useState } from "react";
import { Modal as ModalResponsive } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import "./modal.css";

const Modal = ({
  id,
  display,
  title,
  size,
  children,
  fullMobile,
  hiddeCloseButton,
  onClose,
  titleVariant = "Hero",
  headerClassName,
  onCloseCallback,
}) => {
  const defaultId = useId();

  const [modalContainerStyle, setModalContainerStyle] = useState();
  const [modalWrapperStyle, setModalWrapperStyle] = useState();

  // ✅ Lógica movida directo al useEffect
  useEffect(() => {
    setModalContainerStyle(
      `modal-container-wrapper ${fullMobile ? "modal-container-full-mobile" : ""}`
    );
    setModalWrapperStyle(`modal-content-wrapper modal-size-${size || "large"}`);
  }, [size, fullMobile]);

  const handleClose = () => {
    onClose(false); // Close the modal
    if (onCloseCallback) {
      onCloseCallback(); // Execute the onCloseCallback function if provided
    }
  };

  return (
    <ModalResponsive
      modalId={id || defaultId}
      open={display}
      onClose={handleClose}
      aria-labelledby={title || `modal-${id || defaultId}`}
      center
      showCloseIcon={!hiddeCloseButton}
      closeIcon={<i className="bi bi-x-lg"></i>}
      classNames={{
        modal: modalWrapperStyle,
        overlay: "modal-overlay-wrapper",
        modalContainer: modalContainerStyle,
      }}
      closeOnOverlayClick={false}
    >
      <div className={headerClassName}>
        {title && (
          <div className="modal-container-title">
            <h5 className={titleVariant}>{title}</h5>
          </div>
        )}
      </div>
      <div className="modal-container-body">{children}</div>
    </ModalResponsive>
  );
};

export default Modal;
